'use strict';

(function () {
  'use strict';

  angular.module('msCore').provider('errorRouter', errorRouterProvider);
  /* @ngInject */
  function errorRouterProvider() {
    var provider = this;
    provider.buildRoutes = _buildRoutes;
    provider.$get = ['$state', errorRouterFactory];

    function errorRouterFactory($state) {
      var factory = this;
      factory.router = {
        navigateError: _navigateError,
        navigate404: _navigate404,
        goToState: _goToState
      };
      return factory.router;

      /**
       * The base wrapper function for state.go in this provider
       * @param  {String} name the destination route name
       * @param  {[type]} args containing an optional message, errorCode
       *                       and a flag denoting if a contact us link
       *                       should be shown
       */
      function _goToState(name, args) {
        $state.go(name, args);
      }

      /**
       * A helper function that navigates to the contextual error page
       * @param  {Object} args containing an optional message, errorCode
       *                       and a flag denoting if a contact us link
       *                       should be shown
       */
      function _navigateError(args) {
        _goToState(provider.errorRoute, args);
      }
      /**
       * A helper function that navigates to the contextual 404 page
       * @param  {Object} args containing an optional message and a flag
       *                       denoting if a contact us link should be shown
       */
      function _navigate404(args) {
        _goToState(provider.errorRoute + '.404', args);
      }
    }

    /**
     * Creates the base error route for the consuming context
     * This route is NOT abstract and serves as the generic error location
     * for the consuming context once registered.
     * @param  {String} errorRoute the route name for the base error route
     * @return The built error route definition
     */
    function _buildBaseRoute(errorRoute) {
      return {
        name: errorRoute,
        url: '/error',
        templateUrl: 'vnext/pages/error/error.html',
        controller: 'ErrorPageCtrl',
        controllerAs: 'vm',
        data: {
          noAuth: true
        },
        params: {
          message: 'An error occurred',
          errorCode: null,
          contact: false
        }
      };
    }

    /**
     * Creates a 404 error route for the consuming context
     * This route has no template or view but forwards to the base error route,
     * passing an errorCode in the params
     * @param  {String} errorRoute the base error route name for the context
     * @return The built 404 error route definition
     */
    function _build404Route(errorRoute) {
      var name = errorRoute + '.404';
      return {
        name: name,
        url: '/404',
        data: {
          noAuth: true
        },
        onEnter: ['$state', function ($state) {
          $state.go(errorRoute, {
            message: 'Page not found',
            errorCode: 404,
            contact: false
          });
        }]
      };
    }
    /**
     * Configure the provider context and build the route defns
     * @param  {Object} baseRoutePrefix the base prefix for all routes in this context
     * @return The built routes as an array
     */
    function _buildRoutes(baseRoutePrefix) {
      provider.errorRoute = baseRoutePrefix ? baseRoutePrefix + '.error' : 'error';
      //build the routes
      var base = _buildBaseRoute(provider.errorRoute);
      var fourOhFour = _build404Route(provider.errorRoute);

      //return an array of the route defns for wiring in consumer context
      return [base, fourOhFour];
    }
  }
})();